import React from 'react';
import { Flex, Stack, Text, Title } from '@mantine/core';
import Button from '../../components/elements/Button';
import IconAdd from '../../components/icons/IconAdd';
import AlertInfo from '../../components/elements/AlertInfo';
import PropTypes from 'prop-types';
import TableReasonBlock from './TableReasonBlock';

const ReasonContent = ({
  title,
  txtBtn,
  handleEdit,
  dataRow,
  type,
  handleSwitchStatus,
  handleAdd,
  handleDownloadFile
}) => {

  return (
    <div>
      <Stack mb="md">
        <Title order={5}>{title}</Title>
        <div>
          <Button onClick={handleAdd} style="outlined">
            <Flex align="center" gap="xs">
              <IconAdd/> {txtBtn}
            </Flex>
          </Button>
        </div>
        <AlertInfo type="info"><Text fz={12}>Status aktif akan ditampilkan ketika blokir pelanggan</Text></AlertInfo>
        <TableReasonBlock dataRow={dataRow}
          handleDownloadFile={handleDownloadFile} handleEdit={handleEdit}
          handleSwitchStatus={handleSwitchStatus}
          type={type}
        />
      </Stack>
    </div>
  );
};

export default ReasonContent;

ReasonContent.propTypes = {
  dataRow: PropTypes.array,
  handleAdd: PropTypes.func,
  handleDownloadFile: PropTypes.func,
  handleEdit: PropTypes.func,
  handleSwitchStatus: PropTypes.func,
  title: PropTypes.string,
  txtBtn: PropTypes.string,
  type:PropTypes.string
};
